import axios            from 'axios'
import { centralStore } from '../store/store'

const returnHeaders = () => {
  return {
    headers: {
      'X-CSRFTOKEN': centralStore.getters.getAuth['csrfToken']
    }
  }
}

export const serviceMixin = {
  data () {
    return {}
  },
  methods: {
    // eslint-disable-next-line
    startLoader (loader) {
      return setTimeout(() => {
        loader['loader'] = this.$loading.show({
          // Optional parameters
          container: this.fullPage ? null : this.$refs.formContainer,
          canCancel: true,
          onCancel: this.onCancel,
          color: '#3498db'
        })
      }, 750)
    },
    checkLoader (loader, timeout) {
      if (!loader['loader']) {
        clearTimeout(timeout)
      } else {
        loader['loader'].hide()
      }
    },
    update (apiPrefix, apiUrl, params = '', payload = {}) {
      let loader = {hide: () => true}
      let timeout = this.startLoader(loader)

      return new Promise((resolve, reject) => {
        axios.put(apiPrefix + apiUrl + params, payload, returnHeaders())
          .then(resp => {
            this.checkLoader(loader, timeout);
            resolve(resp)
          }).catch(err => {
            this.checkLoader(loader, timeout);
          reject(err)
        })
      })
    },
    getList (apiPrefix, apiUrl, queryParams = '') {
      let loader = {hide: () => true}
      let timeout = this.startLoader(loader)

      return new Promise((resolve, reject) => {
        axios.get(apiPrefix + apiUrl + queryParams, returnHeaders())
          .then(resp => {
            this.checkLoader(loader, timeout);
            resolve(resp)
          }).catch(err => {
          this.checkLoader(loader, timeout);
          reject(err)
        })
      })
    },
    get (apiPrefix, apiUrl, param, queryParams = '') {
      let loader = {hide: () => true}
      let timeout = this.startLoader(loader)
      return new Promise((resolve, reject) => {
        axios.get(apiPrefix + apiUrl + param + queryParams, returnHeaders())
          .then(resp => {
            this.checkLoader(loader, timeout);
            resolve(resp)
          })
          .catch(err => {
            this.checkLoader(loader, timeout);
            reject(err)
          })
      })
    },
    post (apiPrefix, apiUrl, params = '', payload = {}) {
      let loader = {hide: () => true}
      let timeout = this.startLoader(loader)
      return new Promise((resolve, reject) => {
        axios.post(apiPrefix + apiUrl + params, payload, returnHeaders())
          .then(resp => {
            this.checkLoader(loader, timeout);
            resolve(resp)
          })
          .catch(err => {
            this.checkLoader(loader, timeout);
            reject(err)
          })
      })
    },
    delete (apiPrefix, apiUrl, param) {
      let loader = {hide: () => true}
      let timeout = this.startLoader(loader)
      return new Promise((resolve, reject) => {
        axios.delete(apiPrefix + apiUrl + param, returnHeaders()).then(resp => {
          this.checkLoader(loader, timeout);
          resolve(resp)
        }).catch(err => {
          this.checkLoader(loader, timeout);
          reject(err)
        })
      })
    }
  }
}